import styled from "@emotion/styled";

export const OrderListPageWrapper = styled.div({
	padding: "20px"
});
